<!-- <div class="w-full bg-white rounded-xl shadow-sm border border-[#dce4ef] p-6 mb-6"> -->
<div class="row clearfix" [formGroup]="dataForm">
  @if (data.length) {
  @for (f of data; track f; let od = $odd) {
  @if (f?.groupTitle || f?.groupStart) {
  <div class="col-md-12 col-lg-12 mt-1 mb-1">
    <h6 class="text-muted">{{f?.groupTitle}}</h6>
  </div>
  }
  @if (!f.hidden) {
  <div [class.hide_me]="f?.invisible" class="form-group col-md-{{f?.col_size? f.col_size : '6'}}">
    <label class="block mb-1 text-[0.84rem] font-medium text-[#657084] capitalize">{{f?.title_case == 'NONE' ? f.title :
      f?.title |titlecase}}</label>
    @switch (f.type) {
    @case ('editor') {
    <!-- <app-editor [content]="EDITOR_DATA[f?.colName]"
              (onChangeData)="onDescriptionChange($event,f.colName)"></app-editor> -->
    }
    @case ('chips') {
    <p-chips separator="," (onAdd)="onAddChips($event, f.colName)" [allowDuplicate]="false" styleClass="w-full"
      inputStyleClass="w-full min-h-[36px] px-3 py-1.5 border border-[#dce4ef] rounded-[10px] bg-white text-[#273142] text-[0.84rem] font-medium shadow-none hover:border-[#bfd0e7] hover:bg-[#fbfcfe] focus:border-[var(--theme-bg)] focus:ring-[3px] focus:ring-[var(--theme-bg)]/10 focus:outline-none transition-colors"
      [formControl]="dataForm.controls[f.colName]"></p-chips>
    }
    @case ('select') {
    @if (f.type == 'select') {
    <!-- panelStyleClass="[&_.p-dropdown-items-wrapper]:max-h-60 [&_.p-dropdown-items-wrapper]:overflow-y-auto" -->
    <p-dropdown #dropRef [options]="FORM_SUPPORT_DATA[f?.colName]" [autoDisplayFirst]="false"
      [optionValue]="f?.isEditableDropdown ? null: f?.selectPrimaryKey" [disabled]="f?.readonly? true : false"
      [styleClass]="'w-full min-h-[36px] border border-[#dce4ef] rounded-[10px] bg-white text-[#273142] text-[0.84rem] font-medium shadow-none hover:border-[#bfd0e7] hover:bg-[#fbfcfe] focus:border-[var(--theme-bg)] focus:ring-[3px] focus:ring-[var(--theme-bg)]/10 focus:outline-none transition-colors ' + ((submitted && dataForm.get(f.colName)?.errors) ? 'border-red-500 focus:ring-red-500/10' : '')"
      [filter]="(FORM_SUPPORT_DATA[f?.colName]?.length || 0) > 5 && !f?.isEditableDropdown ? true :false "
      [style]="{'width':'100%'}" [optionLabel]="f?.selectKeyName" (keyup.enter)="dropOnEnter(f.colName,$event)"
      (onChange)="f.event?.name == 'change' && f.event?.isCallback ? onChange(f.colName,$event) : f.event?.name == 'change' ? getFullData(f.event.apiTblName,[],f.event.valueAssign,true,f.colName,f.event?.apiFunName) : ''; "
      [placeholder]="DATA_LOADING[f?.colName] ? 'loading...' : 'Select '+f?.title"
      [formControl]="dataForm.controls[f.colName]" [editable]="f?.isEditableDropdown"
      [filterBy]="f.selectKeyName || 'name'"
      [showClear]="f?.isEditableDropdown ? false: !!dataForm.controls[f.colName].value"
      panelStyleClass="dashboard-filter-dropdown-panel [&_.p-dropdown-items-wrapper]:max-h-60 [&_.p-dropdown-items-wrapper]:overflow-y-auto"
      (keydown.space)="onSpace($event,f)">
      <!-- appendTo="body" -->
    </p-dropdown>
    <ng-container *ngIf="f?.selectionMode=='multiple'" [ngTemplateOutlet]="multipleItemTag"
      [ngTemplateOutletContext]="{item:SELECTED_MULTIPLE_COL_VALUE[f.colName] || [],keyName :f.selectKeyName,colName : f.colName}"></ng-container>
    }
    }
    @case ('MULTISELECT') {
    <!-- panelStyleClass="[&_.p-multiselect-items-wrapper]:max-h-60 [&_.p-multiselect-items-wrapper]:overflow-y-auto" -->
    <p-multiSelect
      [styleClass]="'w-full min-h-[36px] border border-[#dce4ef] rounded-[10px] bg-white text-[#273142] text-[0.84rem] font-medium shadow-none hover:border-[#bfd0e7] hover:bg-[#fbfcfe] focus:border-[var(--theme-bg)] focus:ring-[3px] focus:ring-[var(--theme-bg)]/10 focus:outline-none transition-colors ' + ((submitted && dataForm.get(f.colName)?.errors) ? 'border-red-500 focus:ring-red-500/10' : '')"
      (onChange)="f.event?.name == 'change' && f.event?.isCallback ? onChange(f.colName,$event) : f.event?.name == 'change' ? getFullData(f.event.apiTblName,[],f.event.valueAssign,true,f.colName,f.event?.apiFunName) : ''; "
      [formControl]="dataForm.controls[f.colName]" [options]="FORM_SUPPORT_DATA[f?.colName]"
      [optionLabel]="f?.selectKeyName" [optionValue]="f?.selectPrimaryKey"
      [placeholder]="f?.placeholder ? f.placeholder: f.title"
      panelStyleClass="dashboard-filter-dropdown-panel [&_.p-multiselect-items-wrapper]:max-h-60 [&_.p-multiselect-items-wrapper]:overflow-y-auto">
      <!-- appendTo="body" -->
    </p-multiSelect>
    }
    @case ('checkbox') {
    @for (m of FORM_SUPPORT_DATA[f?.colName]; track m) {
    <label class="flex items-center space-x-2 cursor-pointer mb-2">
      <input [value]="m[f?.selectPrimaryKey]"
        (change)="f.event?.name == 'change' && f.event?.isCallback ? onChange(f.colName,$event) : ''"
        [formControl]="dataForm.controls[f.colName]" type="checkbox"
        class="form-checkbox h-4 w-4 text-[var(--theme-bg)] border-[#dce4ef] rounded focus:ring-[var(--theme-bg)]">
      <span class="text-[#273142] text-[0.84rem] font-medium">{{m[f?.selectKeyName]}}</span>
    </label>
    }
    }
    @case ('radio') {
    <hr class="my-2 border-[#dce4ef]">
    <div class="flex flex-wrap gap-4">
      @for (m of FORM_SUPPORT_DATA[f?.colName]; track m) {
      <div class="flex items-center">
        <input [value]="m[f?.selectPrimaryKey]"
          (change)="f.event?.name == 'change' && f.event?.isCallback ? onChange(f.colName,$event) : ''"
          [formControl]="dataForm.controls[f.colName]" [name]="dataForm.controls[f.colName]" [id]="m[f?.selectKeyName]"
          class="form-radio h-4 w-4 text-[var(--theme-bg)] border-[#dce4ef] focus:ring-[var(--theme-bg)]" type="radio">
        <label [for]="m[f?.selectKeyName]" class="ml-2 text-[#273142] text-[0.84rem] font-medium cursor-pointer">
          {{m[f?.selectKeyName]}}
        </label>
      </div>
      }
    </div>
    }
    @case ('TEXTAREA') {
    <textarea
      class="w-full min-h-[36px] px-3 py-1.5 border border-[#dce4ef] rounded-[10px] bg-white text-[#273142] text-[0.84rem] font-medium shadow-none hover:border-[#bfd0e7] hover:bg-[#fbfcfe] focus:border-[var(--theme-bg)] focus:ring-[3px] focus:ring-[var(--theme-bg)]/10 focus:outline-none transition-colors"
      (paste)="toremoveWhiteSpace()"
      [ngClass]="submitted && dataForm.get(f.colName)?.errors ? 'border-red-500 focus:ring-red-500/10' : ''"
      [formControl]="dataForm.controls[f.colName]"></textarea>
    }
    @case ('DATE') {
    <!-- panelStyleClass="max-h-[320px] overflow-y-auto" -->
    <p-calendar #calender [disabled]="f?.readonly" [dateFormat]="f?.dateFormat || dateFormat"
      [view]="f?.dateViewMode || 'date'" [formControl]="dataForm.controls[f.colName]"
      (onSelect)="onChange(f.colName,$event)" [showTime]="f?.showTime" [showSeconds]="f?.showSeconds"
      [timeOnly]="f?.timeOnly" [minDate]="f?.minDate || undefined" [maxDate]="f?.maxDate || undefined"
      [monthNavigator]="f?.monthNavigator ?true : false" [yearRange]="f?.dateRange"
      [yearNavigator]="f?.yearNavigator ? true : false" styleClass="w-full"
      panelStyleClass="dashboard-filter-calendar-panel"
      [inputStyleClass]="'w-full min-h-[36px] px-3 py-1.5 border border-[#dce4ef] rounded-[10px] bg-white text-[#273142] text-[0.84rem] font-medium shadow-none hover:border-[#bfd0e7] hover:bg-[#fbfcfe] focus:border-[var(--theme-bg)] focus:ring-[3px] focus:ring-[var(--theme-bg)]/10 focus:outline-none transition-colors ' + ((submitted && dataForm.get(f.colName)?.errors) ? 'border-red-500 focus:ring-red-500/10' : '')"
      [placeholder]="f?.placeholder ? f.placeholder: f.title" [selectionMode]="f?.selectionMode || 'single'"
      hourFormat="12" [stepMinute]="f?.stepMinute || 1">
      <!-- appendTo="body" -->
    </p-calendar>
    }
    @case ('DATETIME') {
    <!-- panelStyleClass="p-datepicker max-h-[320px] overflow-y-auto" -->
    <p-calendar #calender [disabled]="f?.readonly" panelStyleClass="p-datepicker dashboard-filter-calendar-panel"
      [dateFormat]="f?.dateFormat || dateFormat" [view]="f?.dateViewMode || 'date'"
      [formControl]="dataForm.controls[f.colName]" (onSelect)="onChange(f.colName,$event)" [showTime]="f?.showTime"
      [showSeconds]="f?.showSeconds" [minDate]="f?.minDate || undefined" [maxDate]="f?.maxDate || undefined"
      [monthNavigator]="f?.monthNavigator ?true : false" [yearRange]="f?.dateRange"
      [yearNavigator]="f?.yearNavigator ? true : false" styleClass="w-full"
      [inputStyleClass]="'w-full min-h-[36px] px-3 py-1.5 border border-[#dce4ef] rounded-[10px] bg-white text-[#273142] text-[0.84rem] font-medium shadow-none hover:border-[#bfd0e7] hover:bg-[#fbfcfe] focus:border-[var(--theme-bg)] focus:ring-[3px] focus:ring-[var(--theme-bg)]/10 focus:outline-none transition-colors ' + ((submitted && dataForm.get(f.colName)?.errors) ? 'border-red-500 focus:ring-red-500/10' : '')"
      [placeholder]="f?.placeholder ? f.placeholder: f.title" [selectionMode]="f?.selectionMode || 'single'"
      hourFormat="12" [stepMinute]="f?.stepMinute || 1">
      <!-- appendTo="body" -->
    </p-calendar>
    }
    @case ('FILE') {
    @if (f?.type=='FILE') {
    <app-image-upload #imageUploader (uploadedFileInfo)="didUpload($event,f?.colName)"
      [inputFile]="fileConfig[f?.colName]">
    </app-image-upload>
    }
    }
    @case ('INFO') {
    @if (f?.controlAction?.operation=='MULTIPLE') {
    <span class="text-[0.84rem] font-medium text-[#273142]">
      {{dataForm?.value[f?.controlAction.controls[0]]
      * dataForm?.value[f?.controlAction.controls[1]]}} {{f?.controlAction.info_text ||
      ''}}</span>
    }
    @if (f?.controlAction?.operation=='ADD') {
    <span class="text-[0.84rem] font-medium text-[#273142]">{{f?.controlAction.controls[0] +
      f?.controlAction.controls[1]}} {{f?.controlAction.info_text || ''}}</span>
    }
    }
    @case ('AUTOCOMPLETE') {
    <!-- panelStyleClass="[&_.p-autocomplete-items]:max-h-60 [&_.p-autocomplete-items]:overflow-y-auto" -->
    <p-autoComplete autocomplete="nope" autocomplete="doNotAutoComplete" [formControl]="dataForm.controls[f.colName]"
      [placeholder]="f?.placeholder ? f.placeholder: f.title" [style]="{'width':'100%'}"
      [inputStyleClass]="'w-full min-h-[36px] px-3 py-1.5 border border-[#dce4ef] rounded-[10px] bg-white text-[#273142] text-[0.84rem] font-medium shadow-none hover:border-[#bfd0e7] hover:bg-[#fbfcfe] focus:border-[var(--theme-bg)] focus:ring-[3px] focus:ring-[var(--theme-bg)]/10 focus:outline-none transition-colors ' + ((submitted && dataForm.get(f.colName)?.errors) ? 'border-red-500 focus:ring-red-500/10' : '')"
      [suggestions]="FORM_SUPPORT_DATA[f?.colName]" [delay]="800"
      [forceSelection]="f?.forceSelection == undefined ? true : f?.forceSelection" [itemSize]="10"
      (onSelect)="onSelectAutocomplete($event,f)" (completeMethod)="filterItems($event,f)" [field]="f?.selectKeyName"
      [unique]="true" [multiple]="f?.selectionMode == 'multiple'"
      panelStyleClass="dashboard-filter-dropdown-panel [&_.p-autocomplete-items]:max-h-60 [&_.p-autocomplete-items]:overflow-y-auto">
      <!-- appendTo="body" -->
      <ng-template let-item pTemplate="item">
        <span class="text-[0.84rem] font-medium text-[#273142]">
          @if (f.autoSearch?.selectFieldKeys) {
          @for (a of f.autoSearch?.selectFieldKeys; track a; let i = $index) {
          {{i !=0 ? ' | ' : '' }} {{item[a]}}
          }
          } @else {
          {{item[f?.selectKeyName]}}
          }
        </span>
      </ng-template>
    </p-autoComplete>
    }
    @case ('COLORPICKER') {
    <p-colorPicker [formControl]="dataForm.controls[f.colName]" [style]="{'width':'100%'}"
      (change)="f.event?.name == 'change' ? onChange(f.colName,$event) : ''; "
      (click)="f.event.name =='click' ? onChange(f.colName,$event) : ''" [disabled]="f?.readonly? true : false"
      [inline]="f?.inline? true:false"></p-colorPicker>
    <strong class="ml-2 text-[0.84rem]"
      [style.color]="dataForm.controls[f.colName]?.value">{{dataForm.controls[f.colName]?.value}}</strong>
    }
    @case ('PASSWORD') {
    <p-password (paste)="toremoveWhiteSpace()" (input)="f?.event?.name == 'input' ? onInput(f.colName,f.event):'';"
      [disabled]="f?.readonly? true : false" (change)="f?.event?.name == 'change' ? onChange(f.colName,$event) : ''; "
      (click)="f?.event?.name =='click' ? onChange(f.colName,$event) : ''" [feedback]="false"
      [inputStyleClass]="'w-full min-h-[36px] px-3 py-1.5 border border-[#dce4ef] rounded-[10px] bg-white text-[#273142] text-[0.84rem] font-medium shadow-none hover:border-[#bfd0e7] hover:bg-[#fbfcfe] focus:border-[var(--theme-bg)] focus:ring-[3px] focus:ring-[var(--theme-bg)]/10 focus:outline-none transition-colors ' + ((submitted && dataForm.get(f.colName)?.errors) ? 'border-red-500 focus:ring-red-500/10' : '')"
      placeholder="{{f?.placeholder ? f.placeholder: f?.title}}" [style]="{'width':'100%'}"
      [formControl]="dataForm.controls[f.colName]" [toggleMask]="true"></p-password>
    }
    @default {
    <div class="{{f?.icon_append ? 'flex items-center' : ''}} relative">
      <input [pKeyFilter]="f?.inputKeyFilter|| defaultKeyFilter" autocomplete="doNotAutoComplete"
        (paste)="toremoveWhiteSpace()" (input)="f?.event?.name == 'input' ? onInput(f.colName,f.event):'';"
        [readonly]="f?.readonly? true : false" (change)="f?.event?.name == 'change' ? onChange(f.colName,$event) : ''; "
        (click)="f?.event?.name =='click' ? onChange(f.colName,$event) : ''"
        placeholder="{{f?.placeholder ? f.placeholder: f?.title}}"
        [ngClass]="'w-full min-h-[36px] px-3 py-1.5 border border-[#dce4ef] rounded-[10px] bg-white text-[#273142] text-[0.84rem] font-medium shadow-none hover:border-[#bfd0e7] hover:bg-[#fbfcfe] focus:border-[var(--theme-bg)] focus:ring-[3px] focus:ring-[var(--theme-bg)]/10 focus:outline-none transition-colors ' + ((submitted && dataForm.get(f.colName)?.errors) ? 'border-red-500 focus:ring-red-500/10' : '') + (f?.icon_append?.category=='PREPAND' ? ' pl-10' : '') + (f?.icon_append?.category=='APPEND' ? ' pr-10' : '')"
        [formControl]="dataForm.controls[f.colName]" type="text">
      @if (f?.icon_append) {
      <div
        [ngClass]="f?.icon_append?.category=='APPEND' ? 'absolute right-0 pr-3 flex items-center pointer-events-none' : 'absolute left-0 pl-3 flex items-center pointer-events-none'">
        <span class="text-[#657084] text-[0.84rem]">{{f?.icon_append?.text}}</span>
      </div>
      }
    </div>
    }
    }
    @if (f?.info) {
    <span class="block text-xs text-[#8a96a8] mt-1 p-1">{{f.info}}</span>
    }
    @for (val of f.validator; track val) {
    @if (dataForm?.get(f.colName)?.errors) {
    @if (submitted && dataForm?.get(f.colName)?.errors[val?.name]) {
    <span class="block text-xs text-red-500 mt-1">
      {{val?.error}}
    </span>
    }
    }
    }
  </div>
  }
  }
  }
  <!-- </div> -->

  <ng-template #multipleItemTag let-item="item" let-keyName="keyName" let-colName="colName">
    @if(item.length){
    <div class="flex flex-wrap gap-1 mt-2">
      @for ( m of $any(item); let i =$index; track m.id;) {
      @if(m[keyName]){
      <span (click)="removeItemTag(i,colName)"
        class="inline-flex items-center px-2 py-1 rounded-[10px] bg-[#dce4ef] text-[#273142] text-[0.84rem] font-medium cursor-pointer hover:bg-[#bfd0e7] transition-colors">
        {{m[keyName]}}
        <i class="las la-minus-circle ml-1"></i>
      </span>
      }
      }
    </div>
    }
  </ng-template>
